export const imagePath = 'https://cu-media.imgix.net';